<template>
  <div>
    <div ref="img" class="box">
      <img class="img-box" :src="imgUrl" alt="" @load="loadImg" draggable="false">
      <div class="border-list" v-for="(x,index) in list" :style="{left: x.pointX+'px',top: x.pointY+'px',width: x.pointWidth+'px',height: x.pointHeight+'px'}" @click="deleteBorder(x,index)" :key="index" :class="[{'select-bg': activeIndex==index},{'select-some':x.select}]" @mousedown="selectBorder(x.id, index)">{{x.id}}</div>
    </div>
    <div v-show="downStatus" ref="dashBox" class="dash-border"  :style="changeStyle"></div>
    <div class="set-area">
      <Page :total="pageTotal" show-elevator :page-size="1" @on-change="pageJump"/>
      <i-button class="submit-btn" type="primary" @click="submitPoint">提交数据</i-button>
    </div>
    <Modal
      v-model="deleteModal"
      title="配置选项"
      @on-ok="modifyInformation"
      width="800"
      @on-cancel="cancel">
      <div class="modify">
        <div class="">
          <Form ref="formItem" :model="formItem" :label-width="80" inline >
            <FormItem label="大题" style="width:350px">
              <Input v-model="formItem.paperSectionTitle" />
            </FormItem>
            <FormItem label="小题" style="width:350px">
              <Input v-model="formItem.questionNo" />
            </FormItem>
            <FormItem label="题型" style="width:350px">
              <Select v-model="formItem.questionType" @on-change="changeQuestionType" :label-in-value="true">
                <Option v-for="item in questionTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="得分" style="width:350px">
              <Input v-model="formItem.score" />
            </FormItem>
            <FormItem label="答案" style="width:350px">
              <Input v-model="formItem.answer" type="textarea"/>
            </FormItem>
            <FormItem>
              <Button @click="submitType" type="primary">提交</Button>
            </FormItem>
            <div>
              <FormItem label="识别" style="width:350px">
                <Select v-model="formItem.ocrType" @on-change="changeOcrType" :label-in-value="true">
                  <Option v-for="item in ocrTypeList" :value="item.value" :key="item.value">{{ item.label}}</Option>
                </Select>
              </FormItem>
              <FormItem label="处理" style="width:350px">
                <Select v-model="formItem.replaceHandles" multiple @on-change="changeReplaceHandl" :label-in-value="true">
                  <Option v-for="item in replaceHandlesList" :value="item.value" :key="item.value">{{ item.label}}</Option>
                </Select>
              </FormItem>
              <FormItem label="判断" style="">
                <RadioGroup v-model="formItem.judgeType" @on-change="changeJudgeType">
                  <Radio :label="x.id" v-for="(x,index) in judgeTypeList" :key="index">{{x.label}}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="" style="">
                <Checkbox v-model="formItem.candidate">是否候选</Checkbox>
              </FormItem>
            </div>
            <div>
              <FormItem label="" style="">
                <Checkbox v-model="formItem.answerType">是否批改</Checkbox>
              </FormItem>
              <FormItem label="" style="">
                <Checkbox v-model="formItem.boxFieldId">是否同题框</Checkbox>
              </FormItem>
              <FormItem label="" style="">
                <Checkbox v-model="formItem.boxGroupId">是否同组框</Checkbox>
              </FormItem>
            </div>
          </Form>
        </div>
<!--        <div class="modify-list">-->
<!--          <div class="modify-list-tit">题型</div>-->
<!--          <Select v-model="questionType" style="width:300px" @on-change="changeQuestionType" :label-in-value="true">-->
<!--            <Option v-for="item in questionTypeList" :value="item.value" :key="item.value">{{ item.label}}</Option>-->
<!--          </Select>-->
<!--        </div>-->
<!--        <div class="modify-list">-->
<!--          <div class="modify-list-tit">识别类型</div>-->
<!--          <Select v-model="discernType" style="width:300px" @on-change="changeDiscernType" :label-in-value="true">-->
<!--            <Option v-for="item in discernTypeList" :value="item.value" :key="item.value">{{ item.label}}</Option>-->
<!--          </Select>-->
<!--        </div>-->
<!--        <div class="modify-list">-->
<!--          <div class="modify-list-tit">答案</div>-->
<!--          <Input v-model="answer" show-word-limit type="textarea" style="width: 300px" />-->
<!--        </div>-->
        <div class="delete">
          <Button type="primary" @click="okDelete">删除</Button>
        </div>
      </div>
    </Modal>
    <Modal
      v-model="selectBorderStatus"
      title=""
      @on-ok="selectType"
      @on-cancel="cancelSelect">
      <div class="modify">
        123
      </div>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
  import {
    _queryBookData,_chapterId,_areaBookData,_deleteBorder,_getOcrParams,_modifyInformation,_getQuestionTypeList,_submitType,_getOCRList,_getReplaceList,_getJudgeList
  } from "../api/api.js";
  import { alertTips } from "../common/common.js";
  import globalData from "../common/Global.js";
  export default {
    data(){
      return {
        spinShow: false,
        imgUrl: '',       //图片url
        downPointX: 0,    //鼠标按下的初始X点位
        downPointY: 0,    //鼠标按下的初始Y点位
        overPointX: 0,    //鼠标移动过程中的X点位
        overPointY: 0,    //鼠标移动过程中的Y点位
        downStatus: false,   //鼠标按下的状态
        minX: 0,          //超出边界临界值
        maxX: 0,
        minY: 0,
        maxY: 0,
        list: [],         //框列表
        imgWidth: 0,      //图片自身的宽度
        imgHeight: 0,     //图片自身的高度
        oldData: [],      //页面接受到的数据
        newData: [],      //页面新生成的数据
        bookId: '',       //教辅编号
        chapterId: '',    //当前章节id
        digest: '',       //当前章节digest
        src: '',
        idList: [],       //页码与点码页对应表
        pageId: '',       //点码id
        boxScrollTop: 0,  //默认卷曲的高度，卷曲的时候高度有问题，为兼容性写法
        deleteModal: false,
        activeId: undefined,
        lastActiveId: undefined,   //记录上一次选中的框的id
        activeIndex: -1,
        xFactor: '',      //x轴系数
        yFactor: '',      //y轴系数
        pageTotal: 0,
        subject: '',    //当前的科目
        questionType: -1,    //选中的题型
        questionTypeName: '',  //选中的题型id
        questionTypeList: [],  //题型列表
        ocrTypeList: [],
        replaceHandlesList:[],   //处理规则列表
        judgeTypeList: [],      //判断类型列表
        discernType: '',  //识别类型
        discernTypeList:[],   //识别类型列表
        OCRData: [],
        OCRFirst: [],
        answer: '',
        shiftStatus: false,    //点击shift
        selectBorderStatus: false,  //同题框模态框
        formItem: {
          showOtherKey: false,
          oldOcrType: '',          //以前的数据（已弃用）
          paperSectionTitle: '',   //大题题型
          questionNo: '',         //小题题型
          questionType: '',      //题型
          score: '',          //得分
          answer: '',         //答案
          ocrType: '',        //更改ocr的类型
          ocrTypeName: '',     //库名称
          replaceHandles: [],  //处理规则
          judgeType: '',       //判断类型
          candidate: false,    //是否候选
          answerType: false,       //是否批改
          boxFieldId: false,      //同题框状态
          boxGroupId: false,      //通组框状态
        },
      }
    },
    created(){
      this.chapterId = this.$route.params.id;
      this.src = this.$route.params.src;
      this.getChapterId();
      this.monitorShift();
      this.getOCRList();
      this.getReplaceList();
      this.getJudgeList()
    },
    mounted(){
      //查询ocr接口参数
      this.getOcrParams()
      //查询题目类型
      this.getQuestionTypeList()
      document.addEventListener('mousedown',this.downPoint)
      document.addEventListener('mousemove',this.overPoint)
      document.addEventListener('mouseup',this.upPoint)
      document.querySelector('.main_content_wrapper').addEventListener('scroll',this.getScrollHeight)
      this.boxScrollTop = document.querySelector('.main_content_wrapper').scrollTop;
    },
    computed: {
      changeStyle(){
        if(!this.overPointX&&!this.overPointY){
          return false
        }
        return {
          left: Math.min(this.downPointX, this.overPointX)+'px',
          top: Math.min(this.downPointY, this.overPointY)+'px',
          width: Math.abs(this.overPointX-this.downPointX)+'px',
          height: Math.abs(this.overPointY-this.downPointY)+'px'
        }
      }
    },
    methods: {
      //获取判断类型列表
      getJudgeList(){
        _getJudgeList().then(res=>{
          if(res.code===0){
            this.judgeTypeList = res.data.map((current,index,arr)=>{
              current.value = current.id;
              current.label = current.name;
              return current
            })
          }
        })
      },
      //更改判断类型列表
      changeJudgeType(n){
        console.log(n);
      },
      //获取识别替换规则
      getReplaceList(){
        _getReplaceList().then(res=>{
          if(res.code===0){
            this.replaceHandlesList = res.data.map((current,index,arr)=>{
              current.value = current.id;
              current.label = current.name;
              return current
            })
          }
        })
      },
      //选中规则
      changeReplaceHandl(n){
        this.replaceHandles = n.map((current)=>{
          return current.value
        });
      },
      //查询识别列表
      getOCRList(){
        _getOCRList().then(res=>{
          if(res.code===0){
            this.ocrTypeList = res.data.map((current,index,arr)=>{
              current.value = current.id;
              current.label = current.name;
              return current
            })
          }
        })
      },
      //更改ocr类型
      changeOcrType(n){
        this.ocrType = n.value;
      },
      //点击modal的提交
      submitType(){
        let data = {
          detailId: this.activeId,
          answer: this.formItem.answer,
          questionType: this.formItem.questionType
        }
        _submitType(data).then(res=>{
          if(res.code===0){
            this.$Message.success('修改成功');
            this.formItem.ocrType = res.data.resourceId;
            this.formItem.replaceHandles = res.data.replaceHandles;
            this.formItem.judgeType = res.data.decideHandle;
            this.formItem.candidate = res.data.candidate;
          }
        })
      },
      //按住SHIFT键多选
      monitorShift(){
        const self = this;
        document.onkeydown = function(e) {
          if(e.key=='Shift'){
            self.shiftStatus = true;
          }
        }
        document.onkeyup = function (e) {
          if(e.key=='Shift'){
            self.shiftStatus = false;
          }
        }
      },
      //根据id获取ocr类型中文名
      getResourceName(id){
        let data = this.ocrTypeList.find((current)=>{
          if(current.id==id){
            return true
          }
        })
        return data['name']
      },
      //修改题型
      modifyInformation(){
        if(!this.questionType){
          alertTips("error", "题型不能为空");
          this.activeIndex = -1;
          this.activeId = undefined;
          return false
        }
        let data = {
          boxGroupId: this.formItem.boxGroupId?1:0,
          detailId: this.activeId,
          questionType: this.formItem.questionType,
          ocrType: this.formItem.oldOcrType,
          answer: this.formItem.answer,
          questionNo: this.formItem.questionNo,
          paperSectionTitle: this.formItem.paperSectionTitle,
          score: this.formItem.score,
          resourceName: this.getResourceName(this.formItem.ocrType),
          resourceId: this.formItem.ocrType,
          replaceHandles: this.formItem.replaceHandles,
          decideHandle: this.formItem.judgeType,
          candidate: this.formItem.candidate,
          answerType: this.formItem.answerType?1:2,
          boxFieldId: this.formItem.boxFieldId?1:0
        }
        _modifyInformation(data).then(res=>{
            this.deleteModal = false;
            this.activeIndex = -1;
            this.lastActiveId = this.activeId;
            this.activeId = undefined;
            this.queryBookData().then(res=>{
              if(res==0){
                this.transformPhonePoint()
              }
            })
        })
      },
      //查询OCR识别参数列表
      getOcrParams(){
        _getOcrParams().then(res=>{
          if(res.code===0){
            this.OCRData = res.data.content;
          }
        }).catch(res=>{
          alertTips("error", "修改失败");
        })
      },
      //获取题型
      getQuestionTypeList(){
        _getQuestionTypeList().then(res=>{
          if(res.code===0){
            this.questionTypeList = res.data.map((current,index,arr)=>{
              current.value = current.id;
              current.label = current.name;
              return current
            })
          }
        })
      },
      //题型改变获取名称
      changeQuestionType(n){
        this.questionTypeName = n.label;
      },
      //查询教辅章节页对应列表
      getChapterId() {
        const self = this;
        self.spinShow = true
        _chapterId(this.chapterId).then(res => {
          self.spinShow = false
          if(res.data.code==0){
            self.idList = res.data.data;
            self.pageId = self.idList[0].name;
            self.pageTotal = res.data.data.length;
            self.queryBookData()
          }
        }).catch(err => {
          alertTips("error", "网络出小差，请重新生成");
        });
      },
      //查询教辅章节数据切题框
      queryBookData() {
        const self = this;
        return new Promise((resolve, reject) => {
          _queryBookData(this.chapterId, this.pageId).then(res=>{
            if(res.data.code==0){
              self.oldData = res.data.data.items;
              self.pageId = res.data.data.pageSerialNo;
              self.chapterId = res.data.data.sheetId;
              self.bookId = res.data.data.bookId;
              self.subject = res.data.data.subject;
              let pageNo = res.data.data.pageNo;
              self.imgUrl = globalData.booksUrl + self.src + '.' + pageNo + ".png"
              resolve(res.data.code)
            }
          })
            .catch(err => {
              alertTips("error", "请求失败");
          });
        })
      },
      //转换为屏幕所用坐标
      transformPhonePoint(){
        const self = this;
        this.list = JSON.parse(JSON.stringify(this.oldData)).map((current,index,arr)=>{
          // current.pointX = current.x*self.imgWidth/self.xFactor/10000;
          // current.pointY = current.y*self.imgHeight/self.yFactor/10000;
          // current.pointWidth = current.width*self.imgWidth/self.xFactor/10000;
          // current.pointHeight = current.height*self.imgHeight/self.yFactor/10000;
          current.pointX = current.x;
          current.pointY = current.y;
          current.pointWidth = current.width;
          current.pointHeight = current.height;
          return current
        })
      },
      //转换为点码坐标
      transformDotPoint(){
        let obj = {}
        obj.page = this.pageId
        let newArr = this.list.slice(this.oldData.length)
        obj.bookBoxInfoList = []
        newArr.forEach(current => {
          let current1 = {}
          // current1.x = parseInt(this.splitNum(current.pointX * this.xFactor / this.imgWidth)*10000)
          // current1.y = parseInt(this.splitNum(current.pointY * this.yFactor / this.imgHeight)*10000)
          // current1.width = parseInt(this.splitNum(current.pointWidth * this.xFactor / this.imgWidth)*10000)
          // current1.height = parseInt(this.splitNum(current.pointHeight * this.yFactor / this.imgHeight)*10000)
          current1.x = parseInt(current.pointX)
          current1.y = parseInt(current.pointY)
          current1.width = parseInt(current.pointWidth)
          current1.height = parseInt(current.pointHeight)
          obj.bookBoxInfoList.push(current1)
        })
        return [obj]
      },
      //截取小数点后几位
      splitNum(tmp){
        var x = (tmp).toString()
        let result = x.substr(0, x.indexOf(".") + 3)
        return result
      },
      //取消
      cancel(){
        this.deleteModal = false;
        this.activeIndex = -1;
        this.activeId = undefined;
        this.formItem.ocrType = '';
        this.formItem.replaceHandles = [];
        this.formItem.judgeType = '';
        this.formItem.candidate = false;
        this.formItem.questionType = ''
        this.formItem.questionNo = ''
        this.formItem.score = ''
        this.formItem.answer = ''
      },
      //确认删除
      okDelete(){
        if(this.activeId!=0&&this.activeId){
          _deleteBorder(this.chapterId,this.activeId).then(res=>{
            if(res.data.code==0){
              this.$Message.success('删除成功');
              this.activeIndex = -1;
              this.activeId = undefined;
              this.queryBookData().then(res=>{
                if(res==0){
                  this.transformPhonePoint()
                }
              })
            }
          }).catch(res=>{
            alertTips("error", "删除失败");
          })
        }else{
          this.list.splice(this.activeIndex, 1)
          this.activeIndex = -1;
          this.activeId = undefined;
        }
      },
      changeDiscernType(){

      },
      selectBorder(id, index){
        if(this.shiftStatus){
          //按住shift开始选框
          this.list.some((current,index,arr)=>{
            if(current.id===id){
              if(current.select){
                current.select = false;
              }else{
                current.select = true;
              }
              return current.id===id
            }
          })
        }
      },
      //点击删除
      deleteBorder(x,index){
        if(!this.shiftStatus){
          this.activeId = x.id;
          this.activeIndex = index;
          this.deleteModal = true;
          this.answer = x.answer;
          this.formItem.answer = x.answer;
          this.formItem.questionType = x.questionType;
          this.formItem.score = x.score
          this.formItem.oldOcrType = x.ocrType;
          this.formItem.answerType = x.answerType==1?true:false;
          this.formItem.candidate = x.candidate;
          this.formItem.boxFieldId = x.boxFieldId?true:false;
          this.formItem.boxGroupId = x.boxGroupId?true:false;
          this.formItem.paperSectionTitle = x.paperSectionTitle;
          this.formItem.questionNo = x.questionNo;
          if(this.activeId==this.lastActiveId){
            this.formItem.ocrType = x.resourceId;
            this.formItem.replaceHandles = x.replaceHandles;
            this.formItem.judgeType = x.decideHandle;
            this.formItem.candidate = x.candidate;
          }
          // this.OCRFirst = this.OCRData.filter((current,index,arr)=>{
          //   return current.subject===this.subject
          // })
          // this.questionType = questionType;
          // this.discernType = ocrType
        }
      },
      selectOCRList(){
        this.discernTypeList = this.OCRFirst.filter((current,index,arr)=>{
          if(this.questionTypeName==current.questionTypeName||!current.questionTypeName){
            current.label = current.parameterName
            current.value = current.parameterName
            return current
          }
        })
      },
      //数据提交
      submitPoint(){
        const self = this;
        if(this.list.length==this.oldData.length){
          this.$Message.success('暂无提交的数据');
          return false
        }else if(this.list.length>this.oldData.length){
          let data = {
            serialNo: '',
            dottedPageType: 2,
            bookId: this.bookId,
            data: this.transformDotPoint(),
            bookSheetId: this.chapterId
          }
          _areaBookData(data).then(res=>{
            if(res.data.code==0){
              this.$Message.success('提交成功');
              self.queryBookData().then(res=>{
                if(res==0){
                  self.transformPhonePoint()
                }
              })
            }
          }).catch(res=>{
            alertTips("error", "请求失败");
          })
        }
      },
      //鼠标按下
      downPoint(e) {
        let x = e.pageX,
          y = e.pageY;
        if(x<this.minX||x>this.maxX){
          return false
        }
        if(y<this.minY||y>this.maxY){
          return false
        }
        this.downPointX = x;
        this.downPointY = y;
        this.downStatus = true;
      },
      //鼠标移动
      overPoint(e){
        if(this.downStatus){
          let x = e.pageX,
            y = e.pageY;
          if(x<this.minX||x>this.maxX){
            return false
          }
          // if(y<this.minY||y>this.maxY){
          //   return false
          // }
          if(y<this.minY||y>this.maxY-this.boxScrollTop){
            return false
          }
          this.overPointX = x;
          this.overPointY = y;
        }
      },
      //鼠标松开
      upPoint(){
        let obj = {};
        if(this.$refs.dashBox.offsetWidth<30||this.$refs.dashBox.offsetHeight<30){
          this.downStatus = false;
          this.downPointX = 0
          this.downPointY = 0
          this.overPointX = 0
          this.overPointY = 0
          return false
        }
        obj.pointX = this.$refs.dashBox.offsetLeft-this.minX,
        obj.pointY = this.$refs.dashBox.offsetTop-this.minY+this.boxScrollTop,
        obj.pointWidth = this.$refs.dashBox.offsetWidth,
        obj.pointHeight = this.$refs.dashBox.offsetHeight;
        this.list.push(obj)
        this.downStatus = false;
        this.downPointX = 0
        this.downPointY = 0
        this.overPointX = 0
        this.overPointY = 0
      },
      //背景图片加载完成
      loadImg(){
        this.minX = this.$refs.img.offsetLeft;
        this.maxX = this.$refs.img.offsetLeft+this.$refs.img.offsetWidth;
        this.minY = this.$refs.img.offsetTop;
        this.maxY = this.$refs.img.offsetTop+this.$refs.img.offsetHeight;
        this.imgWidth = this.$refs.img.offsetWidth;
        this.imgHeight = this.$refs.img.offsetHeight;
        this.xFactor = Number(this.imgWidth / 300 * 25.4 / 1.524).toFixed(2).toString();
        this.yFactor = Number(this.imgHeight / 300 * 25.4 / 1.524).toFixed(2).toString();
        this.transformPhonePoint()
      },
      //获取卷曲的高度
      getScrollHeight(){
        this.boxScrollTop = document.querySelector('.main_content_wrapper').scrollTop
      },
      //翻页
      pageJump(n){
        this.pageId = this.idList[n-1].name;
        this.queryBookData()
      },
      //选择类型
      selectType(){

      },
      //取消选择
      cancelSelect(){
        this.list.forEach((current)=>{
          current.select = false
        })
      }
    },
    watch: {
      //监听题型改变的时候获取
      questionType(newValue,oldValue){
        this.questionTypeList.filter((current,index,arr)=>{
          if(current.id==this.questionType){
            this.questionTypeName = current.name
          }
        })
        this.selectOCRList()
      },
      //松开SHIFT弹出模态框
      shiftStatus(newValue,oldValue){
        if(newValue===false){
          let list = this.list.filter((current)=>{
            return current.select
          })
          if(list.length){
            this.selectBorderStatus = true
          }
        }
      }
    }
  }
</script>

<style scoped>
  .box{
    background: #cccccc;
    margin: 0 auto;
    position: relative;
    display: inline-block;
    /*border: 1px solid #0099FF;*/
  }
  .dash-border{
    border:1px dashed #0099FF;
    background-color:#C3D5ED;
    z-index:1000;
    opacity: 0.6;
    position: absolute;
    box-sizing: border-box;
  }
  .border-list{
    position: absolute;
    box-sizing: border-box;
    border: 1px solid #0099FF;
    cursor: pointer;
  }
  .img-box{
    display: block;
    z-index: -1;
  }
  .select-bg{
    background: #0099FF;
  }
  .select-some{
    background: #cccccc;
  }
  .set-area{
    display: inline-block;
    vertical-align: top;
  }
  .submit-btn{
    margin-top: 20px;
  }
  .modify-list{
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .modify-list-tit{
    width: 100px;
  }
  div{
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/TeachingBorder.vue